import { ReactElement } from 'react';
import { Badge, BadgeProps } from '@fluentui/react-components';
import { CheckmarkCircleRegular, CircleRegular, PlayCircleRegular, SearchRegular } from '@fluentui/react-icons';

import { TASK_STATUS, TTaskStatus } from '../../models';

// Status is conveyed with both an icon and text, never color alone (mirrors the
// change StatusBadge convention).
const STATUS_META: Record<TTaskStatus, { color: BadgeProps['color']; icon: ReactElement }> = {
  [TASK_STATUS.NOT_STARTED]: { color: 'informative', icon: <CircleRegular /> },
  [TASK_STATUS.IN_PROGRESS]: { color: 'brand', icon: <PlayCircleRegular /> },
  [TASK_STATUS.IN_REVIEW]: { color: 'warning', icon: <SearchRegular /> },
  [TASK_STATUS.COMPLETE]: { color: 'success', icon: <CheckmarkCircleRegular /> },
};

export const TaskStatusIcon = ({ status }: { status: TTaskStatus }) => STATUS_META[status]?.icon ?? <CircleRegular />;

type TProps = {
  status: TTaskStatus;
  size?: BadgeProps['size'];
  className?: string;
};

export const TaskStatusBadge = ({ status, size = 'medium', className }: TProps) => {
  const meta = STATUS_META[status] ?? { color: 'subtle', icon: undefined };
  return (
    <Badge appearance="tint" color={meta.color} size={size} icon={meta.icon} className={className}>
      {status}
    </Badge>
  );
};
